import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Client Types',
  basePath: '/clients-type',
  rowKey: 'pid',
  columns: [
    { key: 'type', label: 'Client type', sortable: true },
  ],
  fields: [
    { key: 'pid', label: 'ID', type: 'hidden' },
    { key: 'type', label: 'Client type', type: 'text', required: true },
  ],
  defaultSort: { field: 'type', dir: 'desc' },
});
